<template>
  <div>
    <div class="banner flex-cc">
      <div>
        <div class="title">山东省科教人才发展继续教育平台</div>
        <p>Zhongke (Shandong Province) Construction Safety Training Co., L</p>
      </div>
    </div>
    <!--通告 要闻 政策 登录-->
    <div class="section1">
      <div class="content">
        <div class="section1-top flex-sb">
          <div class="notices">
            <div class="caption flex-sb">
              <div class="tag flex-fs">
                <div>
                  <img src="../assets/image/index/caption_icon.png" alt="" />
                </div>
                通知公告
              </div>
              <div class="more" @click="toJump('/notices')">更多+</div>
            </div>
            <List :data="noticesList" type="2" />
          </div>
          <Login
            @requestLogin="requestLogin"
            :userInfo="userInfo"
            :loginStatus="loginStatus"
          />
        </div>
        <div class="section1-bottom flex-sb">
          <div class="news">
            <div class="caption flex-sb">
              <div class="tag flex-fs">
                <div>
                  <img src="../assets/image/index/caption_icon.png" alt="" />
                </div>
                建设要闻
              </div>
              <div class="more" @click="toJump('/news')">更多+</div>
            </div>
            <List :data="newsList" type="1" />
          </div>
          <div class="policy">
            <div class="caption flex-sb">
              <div class="tag flex-fs">
                <div>
                  <img src="../assets/image/index/caption_icon.png" alt="" />
                </div>
                政策法规
              </div>
              <div class="more" @click="toJump('/policy')">更多+</div>
            </div>
            <List :data="policyList" type="3" />
          </div>
        </div>
      </div>
    </div>
    <!--二级教育流程-->
    <div class="section2 educational-process">
      <div class="caption">二级注册建造师继续教育流程</div>
      <div class="process-content content flex-fs">
        <div class="process-item flex-fs">
          <div class="icon">
            <img src="../assets/image/index/educational1.png" alt="" />
          </div>
          <div class="details">
            <div class="title">注册登录</div>
            <div class="des">
              完成实名注册并登录山东省建设科技与教育协会云平台。
            </div>
          </div>
        </div>
        <div class="process-item flex-fs">
          <div class="icon">
            <img src="../assets/image/index/educational2.png" alt="" />
          </div>
          <div class="details">
            <div class="title">选购课程</div>
            <div class="des">根据专业方向选择符合要求的必修和选修课程。</div>
          </div>
        </div>
        <div class="process-item flex-fs">
          <div class="icon">
            <img src="../assets/image/index/educational3.png" alt="" />
          </div>
          <div class="details">
            <div class="title">在线学习</div>
            <div class="des">
              完成规定学时并通过章节测试，部分课程需达到最低学习时长。
            </div>
          </div>
        </div>
        <div class="process-item flex-fs">
          <div class="icon">
            <img src="../assets/image/index/educational4.png" alt="" />
          </div>
          <div class="details">
            <div class="title">发放证书</div>
            <div class="des">
              学时达标后自动生成电子合格证书，作为延续注册的有效凭证。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--二级教育学习-->
    <div class="section3 content">
      <div class="caption">二级注册建造师继续教育学习</div>
      <Course
        @getCourseData="getCourseData"
        :courseTotal="courseTotal"
        :courseList="courseList"
        :courseTypeList="courseTypeList"
        :catalogueList="catalogueList"
      />
      <div class="pages flex-cc" v-if="courseTotal > 8">
        <el-pagination
          @current-change="changePage"
          background
          layout="prev, pager, next"
          :page-size ="12"
          :page-sizes = "[]"
          :total="courseTotal"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import List from "@/components/List.vue";
import Course from "@/components/Course.vue";
import Login from "@/components/Login.vue";
import {
  getNewsList,
  getCollectIds,
  getCourseList,
  getType,
  login,
  getUserInfo,
} from "@/api";
export default {
  name: "index",
  components: { List, Course, Login },
  data() {
    return {
      registerStatus: false,
      loginStatus: false,
      userInfo: {},
      newsList: [],
      policyList: [],
      noticesList: [],
      courseTypeList: [], //课程类型
      catalogueList: [], //专业目录
      courseList: [],
      courseTotal: 0,
      CourseObj: {
        courseType: "",
        catalogue: "",
        pageSize: "12",
        pageNum: 1,
      },
      fullscreenLoading: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData(2, 6);
      this.getData(1);
      this.getData(3);
      this.getDataType();
      if (localStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.loginStatus = true;
           //打开两个播放页面的时候返回首页重新设置 防止可以重新打开
        if (localStorage.getItem("repeat_unique_playing_page")) {
          let pageId = Math.random().toString(36).substr(2, 9);
          localStorage.setItem("unique_playing_page",pageId);
          localStorage.removeItem("repeat_unique_playing_page")
        }
      } else {
        this.loginStatus = false;
      }

      this.getCourseData({
        courseType: "",
        courseMajor: "",
        pageSize: "12",
        pageNum: 1,
      });
    },
    //建设要闻 1 通知公告2 政策法规3 帮助中心4
    getData(noticeType, pageSize = 5) {
      this.fullscreenLoading = true;
      getNewsList({ noticeType, pageSize }).then((res) => {
        if (noticeType == 1) {
          this.newsList = res.rows;
        } else if (noticeType == 2) {
          this.noticesList = res.rows;
        } else if (noticeType == 3) {
          this.policyList = res.rows;
        }
        this.fullscreenLoading = false;
      });
    },
    getCourseData(CourseObj) {
      this.CourseObj = CourseObj;
      getCourseList(CourseObj).then((res) => {
        this.courseList = res.rows;
        this.courseTotal = res.total;
      });
    },
    changePage(pageNum) {
      this.CourseObj.pageNum = pageNum;
      this.getCourseData(this.CourseObj);
    },
    getDataType() {
      getType("ej_course_type").then((res) => {
        this.courseTypeList = res.data;
        localStorage.setItem("courseTypeList", JSON.stringify(res.data));
        //this.$store.commit("COURSE_TYPE", res.data);
      });
      getType("ej_course_major").then((res) => {
        this.catalogueList = res.data;
        localStorage.setItem("catalogueList", JSON.stringify(res.data));
      });
    },

    toJump(path) {
      this.$router.push({
        path,
      });
    },
    requestLogin(data) {
      login(data).then((res) => {
        if (res.code == 200) {
          this.$notify({
            title: "成功",
            message: "登录成功",
            type: "success",
          });
          localStorage.setItem("token", res.token);
          this.requestUserInfo();
        }
      });
    },
    requestUserInfo() {
      getUserInfo().then((res) => {
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        this.loginStatus = true;
      });
      getCollectIds().then((res) => {
        this.collectArr = res.data;
        localStorage.setItem("collectArr", JSON.stringify(res.data));
      });

      //订单状态
      getType("ej_order_state").then((res) => {
        localStorage.setItem("orderStateList", JSON.stringify(res.data));
      });
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  height: 510px;
  min-width: 1600px;
  background-image: url(../assets/image/index/banner.jpg);
  background-size: cover;
  color: #fff;
  text-align: center;
  .title {
    font-size: 39px;
    margin-bottom: 15px;
  }
  p {
    font-size: 12px;
  }
}

.section1 {
  background-color: #f3f4f8;
  padding-top: 82px;
  padding-bottom: 55px;
  .caption {
    margin-bottom: 28px;
    .tag {
      background: #1265cc;
      border-radius: 5px;
      font-size: 22px;
      color: #fff;
      width: 180px;
      height: 46px;
      font-weight: bold;
      div {
        padding-left: 15px;
        padding-right: 10px;
      }
      img {
        width: 25px;
        vertical-align: sub;
      }
    }
    .more {
      font-size: 18px;
      cursor: pointer;
      color: #1265cc;
    }
  }

  &-top {
    margin-bottom: 50px;
    .notices {
      .list {
        width: 1132px;
        height: 402px;
      }
    }
  }
  &-bottom {
    .news,
    .policy {
      .list {
        width: 782px;
        height: 334px;
      }
    }
  }
}
.pages {
  position: relative;
  top: -65px;
}
.section2,
.section3 {
  padding-top: 85px;
  .caption {
    font-size: 36px;
    text-align: center;
    margin-bottom: 95px;
  }
}
.educational-process {
  .process-content {
    padding-top: 105px;
    .process-item {
      transition: transform 0.3s ease;
      width: 400px;
      height: 240px;
      padding-left: 45px;
      padding-right: 22px;
      border: 1px solid #f4f4f4;
      .icon {
        width: 100px;
        margin-right: 28px;
        img {
          width: 100px;
        }
      }
      .details {
        .title {
          font-size: 28px;
          color: #1265cc;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .des {
          font-size: 18px;
          color: #000;
        }
      }
      &:hover {
        background: #1265cc;
        transform: translateY(-30px);

        .details {
          .title {
            color: #fff;
          }
          .des {
            color: #fff;
          }
        }
      }
    }
  }
}

.section3 {
  margin-top: 20px;
  margin-bottom: 100px;
}
</style>
